import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import autobind from 'autobind-decorator';
import SimpleList from '../../common/SimpleList';
import {
  changeCategory, changeThumbnail,
  setDraftSequence,
  setTags,
  updateDraftCount,
  updateTitleAndContent
} from '../../../actions/post';
import { getEditorContent, setEditorContent } from '../../../lib/PostUtils';
import { showToast } from '../../common/Toast';
import { setTitlePlaceholderColorRed } from '../../../actions';
import { findCategoryById } from '../../../lib/CategoryUtils';

@connect(state => ({
  post: state.post.newPost,
  categories: state.blog.categories,
  draftCount: state.post.draftCount,
  editorMode: state.env.editorMode,
  draftSequence: state.post.draftSequence,
}), dispatch => ({
  handleUpdateDraftCount (count) {
    dispatch(updateDraftCount(count));
  },
  handleUpdateTitleAndContent (title, content) {
    dispatch(updateTitleAndContent(title, content));
  },
  handleSetDraftSequence (draftSequence) {
    dispatch(setDraftSequence(draftSequence));
  },
  handleSetTags (tags) {
    dispatch(setTags(tags));
  },
  setTitlePlaceHolderColorRed () {
    dispatch(setTitlePlaceholderColorRed(true));
  },
  handleChangeCategory (category, viewChannel) {
    dispatch(changeCategory(category, viewChannel));
  },
  handleChangeThumbnail (thumbnail) {
    dispatch(changeThumbnail(thumbnail));
  },
}))
class DraftLayer extends Component {
  constructor (props) {
    super(props);
    this.state = {
      drafts: [],
      initialized: false,
      failed: false,
      fetching: false,
    };
  }

  componentDidMount () {
    const { post } = this.props;
    axios.get(`${appInfo.manageUrl}/drafts`)
      .then(r => r.data.data)
      .then(data => {
        this.setState({
          drafts: data,
          initialized: true,
        });
      })
      .catch(e => {
        this.setState({
          failed: true,
        });
      });
  }

  @autobind
  handleRemove (draft) {
    const { handleUpdateDraftCount, handleSetDraftSequence } = this.props;
    const { drafts } = this.state;

    if (!confirm('임시저장 글을 정말 삭제하시겠습니끼?')) {
      return;
    }

    axios.delete(`${appInfo.manageUrl}/drafts/${draft.sequence}`)
      .then(r => {
        // 현재 로딩해둔걸 삭제했을때, 전역 draftId도 리셋
        if (draft.sequence === this.props.draftSequence) {
          handleSetDraftSequence(null);
        }
        handleUpdateDraftCount(r.data.total);
        this.setState({
          drafts: drafts.filter(d => d.sequence !== draft.sequence),
        });
      })
      .catch(e => {
        console.error(e);
        alert('임시저장본을 삭제하지 못했습니다. 다시 시도해주세요.');
      });
  }

  @autobind
  handleAdd () {
    const { post, onClose, handleUpdateDraftCount, draftSequence, handleSetDraftSequence, setTitlePlaceHolderColorRed } = this.props;
    const { fetching } = this.state;
    if (fetching) {
      return;
    }

    this.setState({
      fetching: true,
    });

    const tags = post.tags.join(',');

    axios.post(draftSequence ? `${appInfo.manageUrl}/drafts/${draftSequence}` : `${appInfo.manageUrl}/drafts`, {
      title: post.title,
      content: post.content,
      tags,
      categoryId: post.category,
      thumbnail: post.thumbnail,
    })
      .then(r => {
        handleSetDraftSequence(r.data.draft.sequence);
        handleUpdateDraftCount(r.data.total);
        showToast('작성 중인 글이 저장되었습니다.', 2000);
        onClose();
      })
      .catch(e => {
        console.error(e);
        if (e.response.data && e.response.data.code === 'CONTENT_OR_TITLE_REQUIRED') {
          setTitlePlaceHolderColorRed();
          document.getElementsByClassName('textarea_tit')[0].focus();
          onClose();
        } else if (e.response.data && e.response.data.message) {
          alert(e.response.data.message);
        } else {
          alert('저장하지 못했습니다. 다시 시도해주세요.');
        }
      })
      .finally(() => {
        this.setState({
          fetching: false,
        });
      });
  }

  isContentAndTitleBothEmpty () {
    const { post, editorMode } = this.props;
    const content = getEditorContent(editorMode);
    const { title } = post;

    return (!title || title.trim() === '') && (!content || content.trim() === '');
  }

  askBeforeApplyDraft () {
    if (this.isContentAndTitleBothEmpty()) {
      return confirm('임시저장된 글을 불러오시겠습니까?');
    } else {
      return confirm('임시저장된 글을 불러오시겠습니까?\n작성 중인 제목과 내용은 사라집니다.');
    }
  }

  setCategory (categoryId) {
    const matchCategory = findCategoryById(this.props.categories, categoryId);

    if (!matchCategory) {
      this.props.handleChangeCategory(0, null);
      return;
    }

    this.props.handleChangeCategory(matchCategory.id, matchCategory.viewChannel);
  }

  @autobind
  handleApplyDraft (draft) {
    const { editorMode, handleUpdateTitleAndContent, onClose, handleSetDraftSequence, draftSequence, handleSetTags, handleChangeThumbnail } = this.props;

    if (draftSequence === draft.sequence) {
      onClose();
      showToast('현재 작성 중인 글입니다.');
      return;
    }


    if (!this.askBeforeApplyDraft()) {
      return;
    }

    axios.get(`${appInfo.manageUrl}/drafts/${draft.sequence}`)
      .then(r => r.data.draft)
      .then(data => {
        handleUpdateTitleAndContent(data.title, data.content);
        setEditorContent(editorMode, data.content);
        handleSetDraftSequence(data.sequence);
        handleSetTags(data.tags.split(',').filter(s => s.length > 0));
        this.setCategory(data.categoryId);
        handleChangeThumbnail(data.thumbnail);
        onClose();
        showToast('글을 불러왔습니다.');
      })
      .catch(e => {
        console.error(e);
        alert('임시저장된 내용을 불러오지 못했습니다.');
      });
  }

  renderContent () {
    const { drafts, initialized, failed } = this.state;

    if (failed) {
      return (
        <div className='message'>임시저장 목록을 불러오는데 실패했습니다.</div>
      );
    }

    if (!initialized) {
      return (
        <div className="box_loading">
          <span className="ico_blog ico_loading">로딩중입니다.</span>
        </div>
      );
    }

    if (drafts.length === 0) {
      return (
        <div className='message'>임시저장된 글이 없습니다.</div>
      );
    }

    return (
      <SimpleList list={drafts} onDelete={this.handleRemove} onSelect={this.handleApplyDraft} />
    );
  }

  render () {
    const { onClose } = this.props;
    const { fetching } = this.state;

    return (
      <div className="inner_editor_layer inner_editor_layer1">
        <div className="layer_head">
          <strong className="tit_layer"> 임시저장</strong>
          <div className="info_explain">
            <span className="mce-ico ico_info">정보</span>
            <div className="layer_info" style={{ top: '33px', left: '-3px' }}>
              <div className="inner_layer">
                최대 100개의 글을 임시저장할 수 있습니다.<br/>
                임시저장 글은 저장일로부터 90일간 보관됩니다.
              </div>
            </div>
          </div>
        </div>
        <div className="layer_body">
          <div className="wrap_save">
            {this.renderContent()}
          </div>
        </div>
        <div className="layer_foot">
          <div className="wrap_btn">
            <button type="button" className="btn btn-cancel" onClick={onClose}>취소</button>
            <button type="button" className="btn btn-default" onClick={this.handleAdd} disabled={fetching}>
              {fetching ? '저장 중' : '임시저장하기'}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default DraftLayer;
